import { SlidersHorizontal } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgTuning = mkIcon(SlidersHorizontal);
